import moment from 'moment';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { numberToNumberSt, isDueDatePassed, generateInvoiceFileName } from '@/utils'
import { keyNamesForValues, installmentsStatus } from './constants'
import Tag from '@/components/common/tag/tag'

import PdfIcon from '@/assets/icons/pdf.png'
import GreyDownload from '@/assets/icons/greyDownload.png'
import LightGreyDownload from '@/assets/icons/lightGreyDownload.png'
import GreyInfo from '@/assets/icons/greyInfo.png'
import RedWarning from '@/assets/icons/redWarning.png'
import PinkFilledHeart from '@/assets/icons/pinkFilledHeart.png'

import './style.css'
import { useEffect } from 'react';
import { themes } from '@/constants/colors_v2';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function EnrolledView(props: any) {
    const { timeline } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    // useEffect(()=>{
    //     console.log(props.getInvoiceErr)
    // },[props.getInvoiceErr])

    const invoiceRowUi = (data: any, source: string) => {
        // console.log(data, source)
        // debugger

        let currentOrderId = "-1"
        let dataToUse: any = {
            amount: 0,
            paymentDate: "",
            currencySymbol: "",
            invoiceDetails: {}
        }
        if (source === "withOutInstallment"
            || source === "fullPayment"
            || source === "extendedOrder") {
            dataToUse = {
                amount: data.grandTotal,
                paymentDate: data.createdAt,
                currencySymbol: props.timelineDetails.currencySymbol,
                invoiceDetails: data
            }
            if (dataToUse.invoiceDetails && dataToUse.invoiceDetails._id) {
                currentOrderId = dataToUse.invoiceDetails._id
            }
        } else {
            dataToUse = {
                amount: data.amount,
                paymentDate: data.invoiceDetails?.createdAt,
                currencySymbol: props.timelineDetails.currencySymbol,
                invoiceDetails: data.invoiceDetails
            }
            if (data.invoiceDetails && data.invoiceDetails._id) {
                currentOrderId = data.invoiceDetails._id
            }

            // exit if invoiceDetails is null
            if (data.status === "paid" && data.invoiceDetails === null) {
                return
            }
        }

        const orderDetails = dataToUse.invoiceDetails
        const pdfFileName = generateInvoiceFileName(orderDetails)
        // console.log(dataToUse, source)
        return (
            <div className='mb-[15px] timelineSectionsCommonPaddingLeft'>
                <div className='handleText1 commonMargin1 flex justify-between'>
                    <p>{moment(dataToUse.paymentDate).format('DD MMM, YYYY')}</p>
                    <p>{props.timelineDetails.currencySymbol}{dataToUse.amount}</p>
                </div>
                {props.getInvoiceErr
                    && props.getInvoiceErr.orderId
                    && data.invoiceDetails?.orderId
                    && props.getInvoiceErr.orderId === data.invoiceDetails?.orderId
                    &&
                    <p className='text-red-500 font-medium'>{props.getInvoiceErr.msg}</p>
                }
                <div
                    onClick={() => props.downloadInvoice(data, source, pdfFileName)}
                    style={{
                        cursor: props.getInvoiceBtnLoading === currentOrderId ? 'not-allowed' : 'pointer',
                        opacity: props.getInvoiceBtnLoading === currentOrderId ? '0.7' : '1'
                    }}

                    className="flex items-center timelineEnrolledSectionInvoiceCon p-[5px] rounded-[5px] cursor-pointer w-full">
                    <img className="w-[28px] h-[28px] mr-[10px]" src={PdfIcon} alt="pdf" />

                    <div className="flex-1 min-w-0">
                        <div className="flex items-center">
                            <p className="overflow-hidden max-[1200px]:whitespace-nowrap text-ellipsis text-[15px] font-medium timelineEnrolledSectionInvoiceConPdfName">
                                {pdfFileName}
                            </p>
                        </div>

                        <p className="text-[15px] timelineEnrolledSectionInvoiceConPdfDate">
                            <span>{moment(dataToUse.paymentDate).format("DD MMM, YYYY")}</span>
                        </p>
                    </div>



                    <button
                    // disabled={props.getInvoiceBtnLoading}
                    // style={{
                    //     cursor: props.getInvoiceBtnLoading ? 'not-allowed' : 'pointer'
                    // }}
                    >
                        <img
                            className="w-[21px] h-[21px] ml-[5px]"
                            src={currentTheme === themes.dark ? LightGreyDownload : GreyDownload}
                            alt="download" />
                    </button>
                </div>
            </div>
        )
    }



    const payBalanceRowUi = (data: any, index: number, source: string) => {
        // debugger
        const amount = props.valueForView[keyNamesForValues.sumUnpaidAmounts]
        const dueDate = props.valueForView[keyNamesForValues.getLastInstallmentDueDate]
        let dataToUse: any = {
            isPaid: false,
            amount: 0,
            extraCharge: 0,
            invoiceDetails: {},
            paymentDate: null,
            dueDate: dueDate,
            installmentNumber: null,
        }
        if (data === null) {
            dataToUse = {
                isPaid: false,
                amount: amount,
                extraCharge: 0,
                invoiceDetails: {},
                paymentDate: null,
                dueDate: dueDate,
                installmentNumber: null,
            }
        } else {
            dataToUse = {
                isPaid: false,
                amount: data.amount,
                extraCharge: data.additionalCharges,
                invoiceDetails: data.invoiceDetails,
                paymentDate: null,
                dueDate: data.dueDate,
                installmentNumber: data.installmentNumber,
            }
        }
        let firstUnpaidIndex = props.timelineDetails.installmentSchedule.findIndex((item: { status: any; }) => item.status === installmentsStatus.pending);
        const payBtnDisable = source !== "fullPayment" && index !== firstUnpaidIndex;
        return (
            ((source === "fullPayment" && props.valueForView[keyNamesForValues.countUnpaidInstallments] > 1) || source === "installment") && (


                <div
                className={` ${isDueDatePassed(dataToUse.dueDate) ? 'payBalanceRowUiCon_yesDueDate' : 'payBalanceRowUiCon_noDueDate'} 
                mb-[15px] rounded-[10px] p-[15px] ml-[22px]`}
                key={index}>

                    <div className='flex justify-between '>
                        <div>
                            {source === "fullPayment" ? (
                                <>
                                    <p className='handleText1 commonMargin1'>{timeline.enrolledSection.payFullBalance}</p>

                                    <p className='text-[14px] payBalanceRowUiCon_noExtraChargeText'>{timeline.enrolledSection.noAdditionalCharge}</p>
                                </>
                            ) : (
                                <>
                                    <p className='handleText1 commonMargin1'>
                                        {numberToNumberSt(index + 1)}{' '}{timeline.enrolledSection.installment}
                                    </p>

                                    <p className='text-[14px] payBalanceRowUiCon_extraChargeText'>
                                        +{dataToUse.extraCharge}{'% '}{timeline.enrolledSection.charges}
                                    </p>
                                </>
                            )}
                        </div>
                        <p>
                            <span className='mr-[12px] handleText1'>
                                {/* {source !== "fullPayment" && props.timelineDetails.currencySymbol} */}
                                {props.timelineDetails.currencySymbol}{dataToUse.amount}
                            </span>
                            <button
                                onClick={() => props.handleInstallmentPayment(dataToUse, source)}
                                disabled={payBtnDisable}
                                style={{
                                    boxShadow: "0px 2px 6px 0px #0000001A",
                                    color: payBtnDisable ? '#4B4B4B' : 'black',
                                    opacity: payBtnDisable ? '55%' : '100%',
                                    cursor: payBtnDisable ? 'not-allowed' : 'pointer'
                                }}
                                className='font-medium handleText1 text-[14px] bg-white py-[6px] px-[18px] my500px:py-[7px] px-[25px] rounded-[10px]'>
                                {timeline.enrolledSection.pay}
                            </button>
                        </p>
                    </div>

                    <hr className='border-t-[0.5px] mt-[10px] mb-[10px]' />

                    <div className='flex justify-between'>
                        <p className='text-[14px] payBalanceRowUiCon_DueDateText'>
                            {timeline.enrolledSection.payBefore}{' '}
                            {moment(dataToUse.dueDate).format("DD MMM, YYYY")}
                        </p>

                        {isDueDatePassed(dataToUse.dueDate) ? (
                            <button
                                className={`${payBtnDisable ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                disabled={payBtnDisable}
                            >
                                <img
                                    onClick={() => { props.payInfoPopup('warning') }}
                                    className='w-[17px] h-[17px]' src={RedWarning} alt='redWarning' />
                            </button>
                        ) : (
                            <button
                                className={`${payBtnDisable ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                disabled={payBtnDisable}
                            >
                                <img
                                    onClick={() => { props.payInfoPopup('info') }}
                                    className='w-[17px] h-[17px]' src={GreyInfo} alt='GreyInfo' />
                            </button>
                        )}
                    </div>
                </div>
            )
        )
    }

    return (
        <div className='enrolledViewMain'>
            {props.timelineDetails.courseType === "free" ?
                (<>
                    <div className='timelineSectionsCommonPaddingLeft w-fit'>
                        <Tag
                            text={timeline.freeAccess}
                            icon={PinkFilledHeart}
                            colorCode="pink"
                            borderR_tl="5px"
                            borderR_tr="5px"
                            borderR_bl="5px"
                            borderR_br="5px"
                            iconWidth="17px"
                            borderWidth="0.5px"
                            textSize="12px"
                            padding_left="10px"
                            padding_top="7px"
                            padding_right="10px"
                            padding_bottom="7px"
                            line_hight="17px"
                        />
                    </div>
                </>
                ) : (
                    <>
                        <p className='handleText1 commonMargin1 timelineSectionsCommonPaddingLeft font-semibold'>
                            {timeline.enrolledSection.summary}
                        </p>

                        <div className='handleText1 enrolledSectionAmountPaid commonMargin1 timelineSectionsCommonPaddingLeft flex justify-between'>
                            <p>{timeline.enrolledSection.amountPaid}</p>
                            <p>
                                {props.valueForView[keyNamesForValues.sumPaidAmounts]}
                            </p>
                        </div>

                        {props.anyInstallmentUnPaid &&
                            <>
                                <div className='handleText1 commonMargin1 flex justify-between'>
                                    <p className='timelineSectionsCommonPaddingLeft'>
                                        {timeline.enrolledSection.minimumAmountPayable}
                                    </p>
                                    <p>{props.valueForView[keyNamesForValues.getFirstUnPaidAmt]}</p>
                                </div>
                                <div className='handleText1 commonMargin1 flex justify-between'>
                                    <p className='timelineSectionsCommonPaddingLeft'>
                                        {timeline.enrolledSection.minimumBalance}
                                    </p>
                                    <p>
                                        {props.timelineDetails.currencySymbol}
                                        {props.timelineDetails.minimumBalance}
                                    </p>
                                    {/* <p>{props.valueForView[keyNamesForValues.getFirstUnPaidAmt]}</p> */}
                                </div>
                            </>
                        }

                        <hr className='border-t-[0.5px] mt-[15px] mb-[15px] ml-[22px]' />

                        <p className='handleText1 timelineSectionsCommonPaddingLeft commonMargin1 font-semibold'>
                            {timeline.enrolledSection.invoices}
                        </p>


                        {props.timelineDetails.orderDetails.paymentStructure !== "installment" &&
                            invoiceRowUi(props.timelineDetails.orderDetails, 'withOutInstallment')
                        }


                        {props.timelineDetails.installmentSchedule &&
                            props.timelineDetails.installmentSchedule.map((installment: any, index: number) => {
                                return installment.status === installmentsStatus.paid && (
                                    <div key={index}>
                                        {invoiceRowUi(installment, 'withInstallment')}
                                    </div>
                                );
                            })
                        }

                        {props.timelineDetails.remainingBalanceOrder &&
                            invoiceRowUi(props.timelineDetails.remainingBalanceOrder, 'fullPayment')
                        }


                        {props.anyInstallmentUnPaid &&
                            <>
                                <hr className='border-t-[0.5px] mt-[15px] mb-[15px] ml-[22px]' />
                                <p className='handleText1 timelineSectionsCommonPaddingLeft commonMargin1 font-semibold'>{timeline.enrolledSection.payBalance}</p>

                                {payBalanceRowUi(null, 0, 'fullPayment')}
                            </>
                        }


                        {props.anyInstallmentUnPaid && props.timelineDetails.installmentSchedule.map((installment: any, index: number) => {
                            return installment.status === installmentsStatus.pending && (
                                <div key={index}>
                                    {payBalanceRowUi(installment, index, 'installment')}
                                </div>
                            );
                        })}


                        {props.timelineDetails.extendedOrders &&
                            props.timelineDetails.extendedOrders.map((extendedOrder: any, index: number) => {
                                return (
                                    <div key={index}>
                                        {invoiceRowUi(extendedOrder, 'extendedOrder')}
                                    </div>
                                )
                            })
                        }

                    </>
                )
            }
        </div>
    );
};

